import React from "react";
import { FlaskConical } from "lucide-react";

import { useDemoStatus } from "@/hooks/useDemoStatus";
import { checksWord, demoUntil } from "@/utils/demo";
import { cn } from "@/utils";

/**
 * Полоса демо-режима над контентом (как Sandbox у Stripe): данные вымышлены,
 * сколько осталось проверок и до какого числа. Боевым пользователям не
 * рендерится.
 */
export const DemoBanner: React.FC = () => {
  const demo = useDemoStatus();
  if (!demo?.is_demo) return null;

  const parts: string[] = [];
  if (demo.sandbox_key) {
    parts.push("Песочница: ключ работает на синтетических данных");
  } else {
    if (demo.remaining != null) parts.push(`осталось ${demo.remaining} ${checksWord(demo.remaining)}`);
    if (demo.expires_at) parts.push(`до ${demoUntil(demo.expires_at)}`);
  }
  const exhausted = demo.remaining === 0;

  return (
    <div
      role="status"
      className={cn(
        "flex flex-wrap items-center gap-x-3 gap-y-1 px-4 py-2 border-b",
        "text-fs-xs",
        exhausted
          ? "bg-error-50 border-error-200 text-error-800 dark:bg-error-900/20 dark:border-error-800 dark:text-error-300"
          : "bg-warning-50 border-warning-200 text-warning-800 dark:bg-warning-900/20 dark:border-warning-800 dark:text-warning-300",
      )}
    >
      <span className="inline-flex items-center gap-1.5 font-semibold">
        <FlaskConical size={14} aria-hidden />
        Демо-режим
      </span>
      <span>
        Данные вымышлены и не относятся к реальным лицам — риск-профиль рассчитан по настоящей методике.
        {parts.length > 0 && <> {parts.join(", ")}.</>}
      </span>
      {exhausted && <span className="font-semibold">Проверки закончились — свяжитесь с менеджером.</span>}
    </div>
  );
};

export default DemoBanner;
